import React from 'react'
import helpers from './helpers'
import { domainSettings } from '../../../../../config/generatedConfig'
const voucherLanguage = ['de', 'en'].indexOf(domainSettings.language.toLowerCase()) >= 0 ? domainSettings.language.toLowerCase() : 'de'
const voucherTranslations = require(`../../../../config/components/vouchers/${voucherLanguage}/`)


const RefundModalContent = ({ refundRule, cancellationFeeRedeemable, refundValue, refundFee, closeModal, handleRefundRequest, id }) => {

  const fullRefundContent = () => (
    <div>
      <p>{voucherTranslations.fullRefundStartFragment} {helpers.toPrice(refundValue.toString())} {voucherTranslations.fullRefundEndFragment}</p>

      <div className='py-4'>
        <button type='button' className='btn btn-primary btn-block' onClick={(e) => handleRefundRequest(e, id)} name='claim-refund'>
          {voucherTranslations.refundMyCard}
        </button>
        <button type='button' className='btn btn-default btn-block' onClick={closeModal} name='no-refund-but-available'>
          {voucherTranslations.keepMyVoucher}
        </button>
      </div>
    </div>
  )

  const partialRefundContent = () => (
    <div>
      <p>
        {voucherTranslations.partialRefundFramentOne} {helpers.toPrice(refundValue.toString())} {voucherTranslations.partialRefundFragmentTwo} {helpers.toPrice(refundFee.toString())} {voucherTranslations.partialRefundFragmentThree}
      </p>
      <div className='py-4'>
        <button type='button' className='btn btn-primary btn-block' onClick={(e) => handleRefundRequest(e, id)} name='claim-refund'>
          {voucherTranslations.refundMyCardLess} {helpers.toPrice(refundFee.toString())} {voucherTranslations.fee}
        </button>
        <button type='button' className='btn btn-default btn-block' onClick={closeModal} name='no-refund-cancel-fee'>
          {voucherTranslations.keepMyVoucherForFullAmount}
        </button>
      </div>
    </div>
  )

  const noRefundContent = () => (
    <div>
      <p>{voucherTranslations.noRefundvoucher}</p>
      <div className='py-4'>
        <button type='button' className='btn btn-default btn-block' onClick={closeModal} name='no-refund-not-available'>
          {voucherTranslations.backToMyVouchers}
        </button>
      </div>
    </div>
  )

  const noRefundRedeemedContent = () => (
    <div>
      <p>{voucherTranslations.noRefundRedeemed}</p>

      <div className='py-4'>
        <button type='button' className='btn btn-default btn-block' onClick={closeModal} name='no-refund-partially-redeemed'>
          {voucherTranslations.backToMyVouchers}
        </button>
      </div>
    </div>
  )

  const nonFlexNoRefundContent = () => (
    <div>
      <p>{voucherTranslations.nonFlexNoRefund}</p>

      <div className='py-4'>
        <button type='button' className='btn btn-default btn-block' onClick={closeModal} name='no-refund-non-flex'>
          {voucherTranslations.backToMyVouchers}
        </button>
      </div>
    </div>
  )

  switch (refundRule) {
    case 'full':
      return fullRefundContent()
    case 'partial':
      return partialRefundContent()
    case 'none':
      return noRefundContent()
    case 'hasRedemption':
      return noRefundRedeemedContent()
    case 'nonFlex':
      return nonFlexNoRefundContent()
  }
}

export default RefundModalContent



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/vouchers/RefundModalContent.jsx